// extracted by mini-css-extract-plugin
export var ctaWrapper = "StepsJCA-module--ctaWrapper--4c043";
export var footer = "StepsJCA-module--footer--70be5";
export var lgBreak = "1200";
export var mdBreak = "992";
export var segmentedControlWrapper = "StepsJCA-module--segmentedControlWrapper--afb51";
export var smBreak = "768";
export var step = "StepsJCA-module--step--3b0c8";
export var steps = "StepsJCA-module--steps--92141";
export var stepsJCA = "StepsJCA-module--stepsJCA--108cf";
export var xsBreak = "480";